const cookieUtil = require('./cookieUtil');

function getLandingChannel() {
    const userContext = cookieUtil.getCookie('userContext');
    if (!userContext) return undefined;

    try {
        return JSON.parse(userContext)?.userProfile?.v1?.landingChannel;
        // eslint-disable-next-line no-empty -- malformed userContext cookies should not block Page events.
    } catch {}
}

module.exports = {
    getLandingChannel
};
